// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EntityPropertyGroupIdBuf } from '../entity/entity-property-group-id-buf.js';
import { UuidBuf } from '../entity/uuid-buf.js';


/**
 * Remember that this data is little endian, but the ordering is big endian.
 * So in order to parse this, you need to parse the group into a hex string,
 * then concat it with the keys transformed into a uuid. On js this is:
 * ```js
 * import { UUID } from uuidv7
 * new UUID(new UInt8Array(key))
 * ```
 */
export class EntityPropertyIdBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EntityPropertyIdBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEntityPropertyIdBuf(bb:flatbuffers.ByteBuffer, obj?:EntityPropertyIdBuf):EntityPropertyIdBuf {
  return (obj || new EntityPropertyIdBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEntityPropertyIdBuf(bb:flatbuffers.ByteBuffer, obj?:EntityPropertyIdBuf):EntityPropertyIdBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EntityPropertyIdBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

group():EntityPropertyGroupIdBuf {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : EntityPropertyGroupIdBuf._Unused;
}

key(obj?:UuidBuf):UuidBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new UuidBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startEntityPropertyIdBuf(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addGroup(builder:flatbuffers.Builder, group:EntityPropertyGroupIdBuf) {
  builder.addFieldInt32(0, group, EntityPropertyGroupIdBuf._Unused);
}

static addKey(builder:flatbuffers.Builder, keyOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, keyOffset, 0);
}

static endEntityPropertyIdBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // key
  return offset;
}

}
